export default __webpack_public_path__ + "static/media/student-more-options.d1737e6b.svg";